module.exports = __webpack_public_path__ + "media/images/closet_wood-498d932b72a6c8f54e6772f34f25c3a8.jpg";